module.exports = __webpack_public_path__ + "static/img/whatsapp-group.f6833d63.png";